import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

import _cookies from "../../../shared/utils/_cookies";

export const enrollToCourseTurma = async ({ courseId, turmaId }) => {
  const body = new FormData();
  body.append(
    "dados",
    `[${JSON.stringify({
      disciplinaid: courseId,
      turmaid: turmaId,
      alunoid: _cookies.getItem("auth").user.alunoid,
    })}]`
  );
  const res = await axios.middleware.post("/aluno.asmx/matriculaEmTurma", body);
  return res[0].data;
};

export const useEnrollToCourseTurma = ({ config, courseId } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...config,
    mutationFn: enrollToCourseTurma,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["enrollableClasses", courseId],
      });
      queryClient.invalidateQueries({ queryKey: ["selfSubscriptionCourses"] });
    },
  });
};
